<script lang="ts" generics="T extends string">
  import type { Component } from 'svelte';
  interface Tab { value: T; label: string; icon?: Component<any>; count?: number | null }
  interface Props {
    value: T;
    tabs: Tab[];
    onchange?: (value: T) => void;
    variant?: 'underline' | 'pills';
  }
  let { value = $bindable(), tabs, onchange, variant = 'underline' }: Props = $props();
</script>

<div class="tabs {variant}" role="tablist">
  {#each tabs as tab (tab.value)}
    <button
      type="button"
      role="tab"
      aria-selected={value === tab.value}
      class:active={value === tab.value}
      onclick={() => {
        value = tab.value;
        onchange?.(tab.value);
      }}
    >
      {#if tab.icon}<tab.icon size={16} />{/if}
      {tab.label}
      {#if tab.count !== undefined && tab.count !== null}<span class="count">{tab.count}</span>{/if}
    </button>
  {/each}
</div>

<style>
  .tabs { display: flex; gap: var(--space-1); overflow-x: auto; scrollbar-width: none; }
  .tabs::-webkit-scrollbar { display: none; }
  .underline { border-bottom: 1px solid var(--border); gap: var(--space-5); }
  button {
    display: inline-flex; align-items: center; gap: var(--space-2);
    background: none; border: 0; color: var(--text-2);
    font-size: var(--text-base); font-weight: var(--weight-semibold); white-space: nowrap;
  }
  button:focus-visible { outline: none; box-shadow: var(--ring); border-radius: var(--radius-xs); }
  .underline button { padding: var(--space-2_5) var(--space-0_5); border-bottom: 2px solid transparent; margin-bottom: -1px; }
  .underline button.active { color: var(--brand); border-bottom-color: var(--brand); }
  .pills button { height: var(--control-h-sm); padding: 0 var(--space-3); border-radius: var(--radius-pill); border: 1.5px solid transparent; }
  .pills button:focus-visible { border-radius: var(--radius-pill); }
  .pills button.active { background: var(--brand-soft); color: var(--brand); border-color: var(--brand); }
  button:hover { color: var(--text); }
  .pills button.active:hover { color: var(--brand); }
  .count { font-size: var(--text-2xs); background: var(--surface-3); color: var(--text-2); padding: var(--space-0_5) var(--space-1_5); border-radius: var(--radius-pill); font-weight: var(--weight-semibold); line-height: var(--leading-none); }
  .active .count { background: var(--brand-soft); color: var(--brand); }
</style>
